import { render } from "./ConfirmCreditTips.vue?vue&type=template&id=b662ca82&ts=true"
import script from "./ConfirmCreditTips.vue?vue&type=script&lang=ts"
export * from "./ConfirmCreditTips.vue?vue&type=script&lang=ts"

import "./ConfirmCreditTips.vue?vue&type=style&index=0&id=b662ca82&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__